import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const SessionTypeCard = ({
  title,
  description,
  icon,
  onClick,
  variant = 'default',
}: {
  title: string
  description: string
  icon: IconProp
  onClick: () => void
  variant?: 'default' | 'secondary'
}) => {
  const baseClasses = `
        group relative cursor-pointer overflow-hidden rounded-xl p-5 text-left transition-all
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
    `
  const variantClasses =
    variant === 'secondary'
      ? 'border border-neutral-300 bg-white hover:border-neutral-400 hover:shadow-md dark:border-neutral-700 dark:bg-neutral-800 dark:hover:border-neutral-600 focus-visible:ring-neutral-500'
      : 'border border-emerald-200 bg-emerald-50 hover:border-emerald-300 hover:shadow-md dark:border-emerald-900/50 dark:bg-emerald-950/30 dark:hover:border-emerald-800 focus-visible:ring-emerald-500'

  return (
    <button onClick={onClick} className={`${baseClasses} ${variantClasses}`}>
      <div
        className={`mb-3 inline-flex rounded-lg p-2 ${
          variant === 'secondary'
            ? 'bg-neutral-100 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300'
            : 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/50 dark:text-emerald-400'
        }`}
      >
        <FontAwesomeIcon icon={icon} className="h-5 w-5" />
      </div>
      <h4 className="text-base font-semibold text-neutral-900 dark:text-neutral-50">
        {title}
      </h4>
      <p className="text-sm mt-1 text-neutral-600 dark:text-neutral-400">
        {description}
      </p>
    </button>
  )
}
